<opac-button
  class="events-button"
  [matMenuTriggerFor]="eventsMenu"
  [ariaLabel]="'events.title' | translate" [opacTooltip]="'events.title' | translate"
  (menuOpened)="loadUserEvents()">
  <opac-icon [badge]="userEventsToday?.length > 0" icon="calendar" slot="only-icon"></opac-icon>
</opac-button>

<mat-menu #eventsMenu="matMenu" class="events-menu">
  <mat-action-list (keydown)="$event.stopPropagation()" [attr.dir]="textDirection">
    <div
      class="notification-container"
      [class.notification-container--fixed-height]="
        !showTodayEvents || userEventsToday?.length === 0
      ">
      <div class="notification-container__date" *ngIf="showTodayEvents">
        <span class="label">{{ 'events.todayLabel' | translate }}</span>
        <span class="full-date">{{ currentDay | date: 'EEEE' }}. {{ currentDay | date: 'mediumDate' }}</span>
      </div>

      <div *ngIf="showTodayEvents" class="notification-container__events">
        <ng-container *ngIf="userEventsToday?.length; else noEventsToday">
          <ng-container *ngFor="let dayEvent of userEventsToday">
            <ng-container *ngFor="let event of dayEvent?.events">
              <user-event-item class="event-component" [userEvent]="event" [isHeader]="true"> </user-event-item>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>

      <div class="all-empty" *ngIf="!showTodayEvents">
        <opac-no-results [label]="'events.noEvents' | translate">
          <opac-no-results-events slot="custom-svg"></opac-no-results-events>
          <opac-no-results-cta>
            {{ 'cta.learning.experience' | translate }}
            <opac-button type="secondary" (click)="exploreLearningExperiences()">
              {{ 'events.browseLearningExperience' | translate }}
            </opac-button>
          </opac-no-results-cta>
        </opac-no-results>
      </div>

      <ng-template #noEventsToday>
        <opac-no-results [label]="'events.noEventsToday' | translate">
          <opac-no-results-events slot="custom-svg"> </opac-no-results-events>
        </opac-no-results>
      </ng-template>

      <div *ngIf="showTodayEvents" class="notification-container__footer">
        <opac-button type="text" (click)="goToEventsSection()">
          {{ 'events.allEvents' | translate }}
          <opac-icon slot="end" [icon]="'navigate_next'"></opac-icon>
        </opac-button>
      </div>
    </div>
  </mat-action-list>
</mat-menu>
